module.exports = "<div class='input-group date' id='{{identifier}}'>\n    <input \n      [disabled]=\"disabled\"\n      type='text'\n      class=\"form-control\" />\n    <span class=\"input-group-addon\">\n        <span class=\"glyphicon glyphicon-calendar\"></span>\n    </span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/controls/date-picker/date-picker.component.html
// module id = ./src/app/shared/components/controls/date-picker/date-picker.component.html
// module chunks = main